<template>
  <component :is="htmlTag" :class="[name]" :style="cssVars">
    <slot />
  </component>
</template>

<script>
import { mapGetters } from 'vuex'
import Viewports from '~/mixins/viewports'
export default {
  mixins: [Viewports],
  props: {
    htmlTag: {
      type: String,
      default: 'div',
    },
    layout: {
      type: Array,
      default() {
        return [{ size: 1, x: 0, width: 12 }]
      },
    },
    reverse: {
      type: Boolean,
      default() {
        return false
      },
    },
  },

  data() {
    return {
      name: 'grid-item',
    }
  },

  computed: {
    ...mapGetters({
      mq: 'globals/getMq',
    }),
    cssVars() {
      const options = Object.assign({}, this.viewport)
      let gridColumn = options.x ? options.x : null
      let gridRow = options.y ? options.y : null

      if (options.x && options.endX) {
        gridColumn = `${options.x} / ${options.endX}`
      } else if (options.x && options.width) {
        gridColumn = `${options.x} / span ${options.width}`
      } else {
        gridColumn = `1 / -1` // defaults to 100% of grid
      }

      if (options.y && options.endY) {
        gridRow = `${options.y} / ${options.endY}`
      } else if (options.y && options.height) {
        gridRow = `${options.y} / span ${options.height}`
      }

      return {
        '--grid-column': gridColumn,
        '--grid-row': gridRow,
        '--justify-self': options.justifySelf,
        '--align-self': options.alignSelf,
        '--order': options.order,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.grid-item {
  grid-column: var(--grid-column);
  grid-row: var(--grid-row);
  order: var(--order);
}
</style>
